export const initAutosizeTextarea = () => {
    const textareas = document.querySelectorAll(`[data-textarea]`);
    if (!textareas.length) return;

    textareas.forEach((textarea) => {
        // textarea.setAttribute(`style`, `height:` + (textarea.scrollHeight) + `px;overflow-y:hidden;`);

        textarea.addEventListener(`input`, (e) => {
            textarea.style.height = 0;
            textarea.style.height = (textarea.scrollHeight) + `px`;
        });
    });
}
